import React, { useState } from 'react';
import { FormFieldHeader } from '../../../../../components/FormFieldHeader';
import { AsyncSelect } from '../../../../../components/Select/async';
import { ScorecardTemplateService } from '../../../../../services/v1/applicant_tracking/ScorecardTemplateService';

export type StartingPoint =
  | { value: string; label: string }
  | 'CUSTOM'
  | undefined;

interface PropTypes {
  name: string;
  onName: (value: string) => void;
  startingPoint: StartingPoint;
  onStartingPointChange: (value: StartingPoint) => void;
}

export function NameAndTemplate(props: PropTypes) {
  const [selectEnabled, setSelectEnabled] = useState<boolean>(
    props.startingPoint != null && props.startingPoint != 'CUSTOM',
  );

  return (
    <div className='border-bottom'>
      <div className='d-flex flex-column w-50 fs-5 py-4 gap-4'>
        <div>
          <FormFieldHeader
            fieldName='Name'
            isRequired={true}
            classNames='fw-semibold'
          />
          <input
            className='form-control fs-5'
            placeholder='Insert scorecard name'
            onChange={(event) => props.onName(event.target.value)}
          />
        </div>
        <div className='d-flex align-items-center'>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              checked={!selectEnabled}
              onChange={() => {
                setSelectEnabled(false);
                props.onStartingPointChange('CUSTOM');
              }}
            />
            <label className='form-check-label'>Custom</label>
          </div>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              checked={selectEnabled}
              onChange={() => {
                setSelectEnabled(true);
                props.onStartingPointChange(undefined);
              }}
            />
            <label className='form-check-label'>Based on template</label>
          </div>
          <AsyncSelect
            className='d-inline-block flex-grow-1'
            loadOptions={loadScorecardTemplates}
            selected={selectedOption(props.startingPoint)}
            onChange={(newOption) => {
              props.onStartingPointChange(newOption);
            }}
            disabled={!selectEnabled}
          />
        </div>
      </div>
    </div>
  );
}

async function loadScorecardTemplates() {
  const list = await ScorecardTemplateService.list({
    expand: ['survey_template'],
  });
  return list.scorecardTemplates.map((template) => {
    return {
      value: template.id.toString(),
      label: template.surveyTemplate.name,
    };
  });
}

function selectedOption(startingPoint: StartingPoint) {
  if (!startingPoint) return undefined;
  if (typeof startingPoint === 'string') return undefined;

  return startingPoint;
}
